module.exports = __webpack_public_path__ + "static/media/bell.300b45b0.svg";